<template>
  <svg
    v-if="icon === 'change-slide'" x="0px" y="0px"
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    style="enable-background:new 0 0 64 64;"
    xml:space="preserve">
    <rect class="st1" width="64" height="64" style="fill:none;"/>
    <rect x="30" y="31" transform="matrix(6.123234e-17 -1 1 6.123234e-17 8 72)" class="st0" width="20" height="2" style="fill:#c9c9c9;"/>
    <polygon class="st0" points="24,42 24,22 39,32 " style="fill:#c9c9c9;"/>
  </svg>
  <svg
    v-else-if="icon === 'dinamo-logo'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="dinamo-logo" transform="translate(-1715 -59)">
      <rect
        id="Rectangle_12"
        data-name="Rectangle 12"
        width="64"
        height="64"
        transform="translate(1715 59)"
        fill="#fff"
        opacity="0"
      ></rect>
      <path
        id="Path_10"
        data-name="Path 10"
        d="M1414.889,33.322c0-4.91-3.033-8.73-8.763-8.73h-5.142V42.1h5.1a8.408,8.408,0,0,0,8.807-8.774M1395,47.344v-28h11.082c8.807,0,14.918,5.584,14.918,13.978,0,8.481-6.111,14.022-14.874,14.022Z"
        transform="translate(339 58.656)"
        fill="#c9c9c9"
      ></path>
      <path
        id="Path_11"
        data-name="Path 11"
        d="M1421.241,22.1a3.5,3.5,0,0,1,7,0,3.5,3.5,0,1,1-7,0"
        transform="translate(341.759 58.383)"
        fill="#c9c9c9"
      ></path>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'dinamo-word'"
    xmlns="http://www.w3.org/2000/svg"
    width="109.924"
    height="23.047"
    viewBox="0 0 109.924 23.047"
  >
    <g id="Dinamo" transform="translate(-556 -477.549)">
      <path
        id="Path_23"
        data-name="Path 23"
        d="M377.585,341.31c0-3.862-2.376-6.866-6.866-6.866h-4.029V348.21h3.995a6.6,6.6,0,0,0,6.9-6.9M362,352.339V330.315h8.684c6.9,0,11.689,4.393,11.689,10.995,0,6.671-4.789,11.03-11.655,11.03Z"
        transform="translate(194 147.861)"
        fill="#2e2e2e"
      ></path>
      <path
        id="Path_24"
        data-name="Path 24"
        d="M383.684,336.43h4.194v15.949h-4.194Zm-.4-4.226a2.493,2.493,0,0,1,4.986,0,2.493,2.493,0,1,1-4.986,0"
        transform="translate(195.431 147.822)"
        fill="#2e2e2e"
      ></path>
      <path
        id="Path_25"
        data-name="Path 25"
        d="M401.788,351.982V342.34c0-2.213-1.157-2.972-2.94-2.972a4.671,4.671,0,0,0-3.632,1.848v10.765h-4.194V336.033h4.194v2.047a7.468,7.468,0,0,1,5.582-2.444c3.533,0,5.216,1.982,5.216,5.086v11.259Z"
        transform="translate(195.951 148.219)"
        fill="#2e2e2e"
      ></path>
      <path
        id="Path_26"
        data-name="Path 26"
        d="M419.117,346.83v-5.614a4.578,4.578,0,0,0-3.6-1.848c-2.411,0-4.062,1.883-4.062,4.622,0,2.773,1.651,4.655,4.062,4.655a4.542,4.542,0,0,0,3.6-1.815m0,5.151v-2.047a6.149,6.149,0,0,1-4.919,2.443c-4,0-7.068-3.038-7.068-8.387,0-5.182,3.006-8.354,7.068-8.354a6.1,6.1,0,0,1,4.919,2.444v-2.047h4.226v15.949Z"
        transform="translate(197.034 148.219)"
        fill="#2e2e2e"
      ></path>
      <path
        id="Path_27"
        data-name="Path 27"
        d="M444.767,351.982v-10.07c0-1.488-.661-2.543-2.378-2.543a4.234,4.234,0,0,0-3.3,1.848v10.765h-4.225v-10.07c0-1.488-.661-2.543-2.379-2.543a4.345,4.345,0,0,0-3.3,1.848v10.765h-4.193V336.033h4.193v2.047a7.14,7.14,0,0,1,5.215-2.444c2.346,0,3.864,1.09,4.426,2.873a6.836,6.836,0,0,1,5.482-2.873c2.937,0,4.687,1.553,4.687,4.822v11.524Z"
        transform="translate(198.234 148.219)"
        fill="#2e2e2e"
      ></path>
      <path
        id="Path_28"
        data-name="Path 28"
        d="M461.7,343.99c0-2.476-1.45-4.622-4.093-4.622-2.608,0-4.062,2.146-4.062,4.622,0,2.51,1.454,4.655,4.062,4.655,2.642,0,4.093-2.145,4.093-4.655m-12.513,0a8.437,8.437,0,1,1,8.42,8.387,8.078,8.078,0,0,1-8.42-8.387"
        transform="translate(199.861 148.219)"
        fill="#2e2e2e"
      ></path>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'facebook'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="facebook" transform="translate(-1953 -64)">
      <rect
        id="Rectangle_8"
        data-name="Rectangle 8"
        width="64"
        height="64"
        transform="translate(1953 64)"
        fill="#fff"
      ></rect>
      <g id="Group_9" data-name="Group 9" transform="translate(327 -50)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M137,659a14,14,0,1,1-14,14,14.015,14.015,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
          transform="translate(1521 -527)"
          fill="#c9c9c9"
        ></path>
        <path
          id="Path_2"
          data-name="Path 2"
          d="M140.533,670.58l-.184,2.393H137.9v8.316h-3.1v-8.316h-1.655V670.58h1.655v-1.609a4.294,4.294,0,0,1,.533-2.478,2.943,2.943,0,0,1,2.568-1.2,10.432,10.432,0,0,1,2.966.3l-.414,2.451a5.592,5.592,0,0,0-1.333-.2c-.643,0-1.219.23-1.219.873v1.869Z"
          transform="translate(1521 -527)"
          fill="#c9c9c9"
        ></path>
      </g>
    </g>
  </svg>

  <svg
    v-else-if="icon === 'hamburger-close'"
    xmlns="http://www.w3.org/2000/svg"
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    x="0px"
    y="0px"
    transform-origin="50% 50%"
  >
    <g id="close">
      <rect
        x="12"
        y="32"
        transform="matrix(-0.7071068 -0.7071068 0.7071068 -0.7071068 33 79.6690445)"
        fill="#777"
        width="42"
        height="2"
      />
      <rect
        x="12"
        y="32"
        transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -13.6690474 33)"
        fill="#777"
        width="42"
        height="2"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'hamburger'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="hamburger" transform="translate(-1856)">
      <rect
        id="Rectangle_2"
        data-name="Rectangle 2"
        width="32"
        height="2"
        transform="translate(1872 31)"
        fill="#777"
      ></rect>
      <rect
        id="Rectangle_3"
        data-name="Rectangle 3"
        width="32"
        height="2"
        transform="translate(1872 19)"
        fill="#777"
      ></rect>
      <rect
        id="Rectangle_4"
        data-name="Rectangle 4"
        width="16"
        height="2"
        transform="translate(1872 44)"
        fill="#777"
      ></rect>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'instagram'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="instagram" transform="translate(-1953 -190)">
      <rect
        id="Rectangle_10"
        data-name="Rectangle 10"
        width="64"
        height="64"
        transform="translate(1953 190)"
        fill="#fff"
      ></rect>
      <g id="Group_11" data-name="Group 11" transform="translate(199 76)">
        <path
          id="Path_5"
          data-name="Path 5"
          d="M265,659a14,14,0,1,1-14,14,14.015,14.015,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
          transform="translate(1521 -527)"
          fill="#c9c9c9"
        ></path>
        <g id="Group_6" data-name="Group 6" transform="translate(1521 -527)">
          <path
            id="Path_6"
            data-name="Path 6"
            d="M268.468,665.444h-6.936a4.3,4.3,0,0,0-4.3,4.3v7.4a4.3,4.3,0,0,0,4.3,4.3h6.936a4.3,4.3,0,0,0,4.3-4.3v-7.4A4.3,4.3,0,0,0,268.468,665.444ZM265,677.234a3.814,3.814,0,1,1,0-7.628,3.567,3.567,0,0,1,3.814,3.814A3.844,3.844,0,0,1,265,677.234Zm4.7-7.46a1.07,1.07,0,1,1,1.07-1.07A1.07,1.07,0,0,1,269.7,669.774Z"
            fill="#c9c9c9"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'linkedin'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="linkedin" transform="translate(-1953 -254)">
      <rect
        id="Rectangle_11"
        data-name="Rectangle 11"
        width="64"
        height="64"
        transform="translate(1953 254)"
        fill="#fff"
      ></rect>
      <g id="Group_12" data-name="Group 12" transform="translate(135 140)">
        <path
          id="Path_7"
          data-name="Path 7"
          d="M329,659a14,14,0,1,1-14,14,14.015,14.015,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
          transform="translate(1521 -527)"
          fill="#c9c9c9"
        ></path>
        <g id="Group_8" data-name="Group 8" transform="translate(1521 -527)">
          <path
            id="Path_8"
            data-name="Path 8"
            d="M322.264,669.313h3.325V680h-3.325ZM323.927,664A1.927,1.927,0,1,1,322,665.926,1.926,1.926,0,0,1,323.927,664"
            fill="#c9c9c9"
          ></path>
          <path
            id="Path_9"
            data-name="Path 9"
            d="M327.672,669.313h3.184v1.461h.046a3.489,3.489,0,0,1,3.142-1.727c3.364,0,3.985,2.213,3.985,5.092V680h-3.321v-5.2c0-1.24-.021-2.834-1.726-2.834-1.728,0-1.992,1.351-1.992,2.745V680h-3.318Z"
            fill="#c9c9c9"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'twitter'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="twitter" transform="translate(-1953 -126)">
      <rect
        id="Rectangle_9"
        data-name="Rectangle 9"
        width="64"
        height="64"
        transform="translate(1953 126)"
        fill="#fff"
      ></rect>
      <g id="Group_10" data-name="Group 10" transform="translate(263 12)">
        <path
          id="Path_3"
          data-name="Path 3"
          d="M201,659a14,14,0,1,1-14,14,14.015,14.015,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
          transform="translate(1521 -527)"
          fill="#c9c9c9"
        ></path>
        <g id="Group_4" data-name="Group 4" transform="translate(1521 -527)">
          <path
            id="Path_4"
            data-name="Path 4"
            d="M209.393,670.237c.008.16.011.322.011.487a10.769,10.769,0,0,1-16.58,9.074,7.95,7.95,0,0,0,.9.053,7.583,7.583,0,0,0,4.7-1.62,3.791,3.791,0,0,1-3.535-2.631,3.727,3.727,0,0,0,.713.069,3.854,3.854,0,0,0,1-.133,3.791,3.791,0,0,1-3.038-3.713v-.048a3.731,3.731,0,0,0,1.715.473,3.8,3.8,0,0,1-1.172-5.057,10.761,10.761,0,0,0,7.8,3.959,3.856,3.856,0,0,1-.1-.865,3.79,3.79,0,0,1,6.551-2.591,7.592,7.592,0,0,0,2.4-.918,3.791,3.791,0,0,1-1.665,2.094,7.565,7.565,0,0,0,2.176-.6,7.683,7.683,0,0,1-1.889,1.963Zm0,0"
            fill="#c9c9c9"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  <svg
    v-else-if="icon === 'edit'"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="pencil-alt"
    class="svg-inline--fa fa-pencil-alt fa-w-16"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ></path>
  </svg>
</template>

<script>
export default {
  props: {
    icon: {
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
svg {
  width: 64px;
  height: 64px;
}
</style>
